import { useEffect, useState } from 'react';
import { useTimeout } from 'site-modules/shared/hooks/use-timeout';
import { logger } from 'client/utils/logger/logger';
import { getNewPageCanvasUrl, getIframeUrl } from 'site-modules/canvas/utils/canvas-links';
import { LOADING_TIMEOUT } from 'site-modules/canvas/constants/canvas';
import { venomHistory } from 'client/utils/history/venom-history';
import { usePrevious } from 'client/site-modules/shared/hooks/use-previous';

export function useIframeLoad({ iframeRef, iframeSrc, location }) {
  const [isLoading, setLoading] = useState(!!iframeSrc);
  const prevIframeSrc = usePrevious(iframeSrc);
  const [setLoadingTimeout, clearLoadingTimeout] = useTimeout();

  if (iframeSrc !== prevIframeSrc) {
    setLoading(!!iframeSrc);
  }

  useEffect(() => {
    clearLoadingTimeout();
    if (!isLoading) {
      return;
    }

    setLoadingTimeout(() => {
      logger.warn(`Canvas: Infinite loading. Url: ${getIframeUrl(iframeRef)}`);
      setLoading(false);
    }, LOADING_TIMEOUT);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, iframeSrc]);

  function onLoad() {
    function beforeUnload() {
      setLoading(true);
    }

    document.title = iframeRef?.current?.contentDocument?.title || 'Edmunds';
    const iframeWindow = iframeRef?.current?.contentWindow;
    venomHistory.replace(getNewPageCanvasUrl(location.pathname, iframeRef));

    setLoading(false);

    const responseStatus = iframeWindow?.performance?.getEntriesByType?.('navigation')?.[0]?.responseStatus;
    if (responseStatus && responseStatus >= 400) {
      logger.warn(
        `Canvas: Invalid response status code. Status code: ${responseStatus}. Url: ${getIframeUrl(iframeRef)}`
      );
    }

    iframeWindow?.addEventListener('beforeunload', beforeUnload);
  }

  return { onLoad, isLoading };
}
